<div
    class="button-group-title"
    *ngIf="title"
>
    {{title}}
</div>
<div class="button-group-container">
    <div class="button-group-inner-container">
        <dodo-button
            *ngFor="let button of buttons"
            [settings]="button"
        ></dodo-button>
    </div>

    <ng-content></ng-content>

</div>
